import React, { useState } from 'react';
import { 
  UserGroupIcon, 
  ClipboardDocumentListIcon, 
  UserIcon,
  ArchiveBoxIcon,
  TruckIcon,
  ShieldCheckIcon,
  BeakerIcon,
  BuildingOfficeIcon,
  CogIcon
} from '@heroicons/react/24/outline';

interface AdminLayoutProps {
  children: React.ReactNode;
}

type AdminTab = 'users' | 'treatments' | 'doctors' | 'categories' | 'fournisseurs' | 'assureurs' | 'medicaments' | 'prestataires' | 'types-protheses';

interface AdminTabInfo {
  id: AdminTab;
  label: string;
  icon: React.ComponentType<{ className?: string }>;
}

const adminTabs: AdminTabInfo[] = [
  { id: 'users', label: 'Utilisateurs', icon: UserGroupIcon },
  { id: 'treatments', label: 'Types de Traitement', icon: ClipboardDocumentListIcon },
  { id: 'doctors', label: 'Médecins', icon: UserIcon },
  { id: 'medicaments', label: 'Médicaments', icon: BeakerIcon },
  { id: 'categories', label: 'Catégories Stock', icon: ArchiveBoxIcon },
  { id: 'fournisseurs', label: 'Fournisseurs', icon: TruckIcon },
  { id: 'assureurs', label: 'Assureurs', icon: ShieldCheckIcon },
  { id: 'prestataires', label: 'Prestataires', icon: BuildingOfficeIcon },
  { id: 'types-protheses', label: 'Types Prothèses', icon: CogIcon },
];

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const [activeTab, setActiveTab] = useState<AdminTab>('users');

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="bg-white shadow">
        <div className="px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-6">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Administration</h1>
              <p className="mt-1 text-sm text-gray-500">
                Gérez les utilisateurs, types de traitement, médecins et paramètres système
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="px-4 sm:px-6 lg:px-8 py-8">
        <div className="bg-white rounded-lg shadow">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex space-x-8 px-6" aria-label="Tabs">
              {adminTabs.map((tab) => {
                const Icon = tab.icon;
                return (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm ${
                      activeTab === tab.id
                        ? 'border-blue-500 text-blue-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    <Icon
                      className={`-ml-0.5 mr-2 h-5 w-5 ${
                        activeTab === tab.id
                          ? 'text-blue-500'
                          : 'text-gray-400 group-hover:text-gray-500'
                      }`}
                    />
                    {tab.label}
                  </button>
                );
              })}
            </nav>
          </div>

          <div className="p-6">
            {React.cloneElement(children as React.ReactElement, { activeTab })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;